<div class="page-header clearfix">
  <a class="page-header__back" uiSref="project-deploys">&lsaquo; Deploys</a>
  <h1 class="page-header__title">
    <span *ngIf="deploy.revision">
      {{ deploy.revision | truncate: 7 }}
      &nbsp;<i
        class="glyphicon glyphicon-ab-layers"
        ngbTooltip="Redeploy"
        *ngIf="deploy.redeploy"
      ></i></span
    ><span *ngIf="!deploy.revision">Deploy</span>
  </h1>
  <span class="page-header__element">{{ project.name }} deploy</span
  ><span class="page-header__element">by {{ deploy.username }}</span
  ><span class="page-header__element">to</span
  ><span class="page-header__element">
    <ab-env-label [env]="deploy.environment"></ab-env-label
  ></span>
</div>
<div class="bkg-color--white">
  <div class="container">
    <div class="row pt-3">
      <div class="col-lg-5">
        <table class="kv-table mb-3">
          <tr>
            <td class="kv-table__key kv-table__kv--no-top-padding">
              Deployed At
            </td>
            <td class="kv-table__value kv-table__kv--no-top-padding">
              {{ deploy.createdAt | date: "h:mm a - MMMM dd, y" }}
              (<ab-time-ago [time]="deploy.createdAt"></ab-time-ago>)
            </td>
          </tr>
          <tr>
            <td class="kv-table__key kv-table__kv--no-top-padding">
              Replaced At
            </td>
            <td
              class="kv-table__value kv-table__kv--no-top-padding"
              *ngIf="next"
            >
              {{ next.createdAt | date: "h:mm a - MMMM dd, y" }}
              (<ab-time-ago [time]="next.createdAt"></ab-time-ago>)
            </td>
            <td
              class="kv-table__value kv-table__kv--no-top-padding"
              *ngIf="!next"
            >
              Currently Active
            </td>
          </tr>
          <tr>
            <td class="kv-table__key kv-table__kv--no-top-padding">
              Active for
            </td>
            <td class="kv-table__value kv-table__kv--no-top-padding">
              {{ deploy.deployAge | timeFormat }}
            </td>
          </tr>
          <tr *ngIf="deploy.version">
            <td class="kv-table__key kv-table__kv--no-top-padding">Version</td>
            <td class="kv-table__value kv-table__kv--no-top-padding">
              {{ deploy.version }}
            </td>
          </tr>
        </table>
      </div>
      <div class="col-lg-7">
        <div class="ab-cards">
          <div
            class="ab-card"
            ngbTooltip="Errors that have not reoccurred since this deploy marked them as resolved."
          >
            <a
              *ngIf="deploy.groupResolvedCount > 0"
              uiSref="project-errors"
              [uiParams]="{
                projectId: project.id,
                filters: { resolved_by_deploy_id: deploy.id, resolved: 'any' }
              }"
              >Fixed errors</a
            ><span *ngIf="deploy.groupResolvedCount === 0">Fixed errors</span>
            <h1 class="ab-card__data">
              {{ deploy.groupResolvedCount | numberToHuman }}
            </h1>
          </div>
          <div
            class="ab-card"
            ngbTooltip="Errors that were first seen while this deploy was active."
          >
            <a
              *ngIf="deploy.groupCreatedCount > 0"
              uiSref="project-errors"
              [uiParams]="{
                projectId: project.id,
                filters: { deploy_id: deploy.id, resolved: 'any' }
              }"
              >Introduced errors</a
            ><span *ngIf="deploy.groupCreatedCount === 0"
              >Introduced errors</span
            >
            <h1 class="ab-card__data ab-card__data--orange">
              {{ deploy.groupCreatedCount | numberToHuman }}
            </h1>
          </div>
          <div
            class="ab-card"
            ngbTooltip="Total error occurrences while this deploy was active."
          >
            Occurrences
            <h1 class="ab-card__data">
              {{ deploy.noticeTotalCount | numberToHuman }}
            </h1>
          </div>
          <div
            class="ab-card"
            ngbTooltip="Frequency of error occurences while this deploy was active."
          >
            Occurrence rate
            <h1 class="ab-card__data" *ngIf="deploy.occurrenceRate >= 0.1">
              {{ deploy.occurrenceRate.toFixed(1) | numberToHuman
              }}<span class="text-unit">/min</span>
            </h1>
            <h1
              class="ab-card__data"
              *ngIf="deploy.occurrenceRate < 0.1 && deploy.occurrenceRate > 0"
            >
              ~0<span class="text-unit">/min</span>
            </h1>
            <h1 class="ab-card__data" *ngIf="deploy.occurrenceRate === 0">
              0<span class="text-unit">/min</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <h3>Changes</h3>
    <div class="row mb-3">
      <div class="col-lg-6">
        <table class="kv-table">
          <tr *ngIf="!deploy.revision">
            <td class="kv-table__key kv-table__kv--no-top-padding">Compare</td>
            <td class="kv-table__value kv-table__kv--no-top-padding">
              Unknown (deploy revision was not provided -
              &nbsp;<ab-external-link href="https://docs.airbrake.io/docs/features/deploy-tracking/"
                >learn more</ab-external-link
              >)
            </td>
          </tr>
          <tr *ngIf="deploy.revision">
            <td class="kv-table__key kv-table__kv--no-top-padding">Compare</td>
            <td
              class="kv-table__value kv-table__kv--no-top-padding"
              *ngIf="!deploy.redeploy"
            >
              <ab-external-link
                *ngIf="deploy.linkUrl"
                href="{{ deploy.linkUrl }}"
                ><span *ngIf="deploy.previousRevision"
                  >{{ deploy.previousRevision | truncate: 7 }}...</span
                ><span>{{
                  deploy.revision | truncate: 7
                }}</span></ab-external-link
              >
            </td>
            <td
              class="kv-table__value kv-table__kv--no-top-padding"
              *ngIf="deploy.redeploy"
            >
              Nothing to compare. This redeployed the same revision<span
                *ngIf="deploy.linkUrl"
              >
                &nbsp; (<ab-external-link href="{{ deploy.linkUrl }}">{{
                  deploy.revision | truncate: 7
                }}</ab-external-link
                >)</span
              >&nbsp; as the previous &nbsp;
              <ab-env-label [env]="deploy.environment"></ab-env-label>&nbsp;
              deploy.
            </td>
          </tr>
          <tr *ngIf="pullRequests?.length">
            <td class="kv-table__key kv-table__kv--no-top-padding">
              Pull Requests
            </td>
            <td class="kv-table__value kv-table__kv--no-top-padding">
              <span
                *ngFor="
                  let pullRequest of pullRequests;
                  let last = last;
                  trackBy: pullRequestTrackBy
                "
                ><ab-external-link
                  ngbTooltip="{{ pullRequest.title }}"
                  href="{{ pullRequest.url }}"
                  >{{ pullRequest.pr_id }}</ab-external-link
                ><span *ngIf="!last"> , &nbsp;</span></span
              >
            </td>
          </tr>
        </table>
      </div>
      <div class="col-lg-6" *ngIf="diffStats">
        <div class="ab-cards">
          <div class="ab-card">
            Changed files
            <h1 class="ab-card__data">
              {{ diffStats?.file_diff_stats.length }}
            </h1>
          </div>
          <div class="ab-card">
            Additions
            <h1 class="ab-card__data">
              <span class="color--success">{{ diffStats.additions }}</span>
            </h1>
          </div>
          <div class="ab-card">
            Deletions
            <h1 class="ab-card__data">
              <span class="color--danger">{{ diffStats.deletions }}</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!diffStats?.raw_diff">
      <div class="col-lg-12">
        <ngb-accordion
          #acc="ngbAccordion"
          [destroyOnHide]="false"
          *ngFor="
            let fileDiffStat of diffStats?.file_diff_stats;
            let index = index;
            trackBy: trackByIndex
          "
        >
          <ngb-panel id="panel-{{ index }}">
            <ng-template ngbPanelTitle="ngbPanelTitle"
              ><i
                class="card-title-content__icon glyphicon glyphicon-ab-plus"
                [ngClass]="{ 'is-opened': acc.isExpanded('panel-' + index) }"
              ></i
              ><span class="text-truncate" *ngIf="fileDiffStat.prev_file">{{
                fileDiffStat.prev_file
              }}</span
              ><i
                class="glyphicon glyphicon-arrow-right ab-arrow-right"
                *ngIf="fileDiffStat.prev_file"
              ></i
              >{{ fileDiffStat.file
              }}<span
                class="card-title-content__small card-title-content__value card-title-content__no-shrink"
                ><span class="color--success"
                  >+{{ fileDiffStat.additions }}</span
                >&nbsp;<span class="color--danger"
                  >-{{ fileDiffStat.deletions }}</span
                ></span
              ></ng-template
            >
            <ng-template ngbPanelContent="ngbPanelContent">
              <table class="blob">
                <tbody>
                  <tr
                    *ngFor="
                      let line of fileDiffStat.diff;
                      trackBy: diffStatsLineTrackBy
                    "
                  >
                    <td
                      class="blob-code"
                      [ngClass]="{
                        'blob-code--addition': line.indexOf('+') === 0,
                        'blob-code--deletion': line.indexOf('-') === 0,
                        'blob-code--summary': line.indexOf('@@') === 0
                      }"
                    >
                      {{ line }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>
    </div>
    <div class="row" *ngIf="diffStats?.raw_diff">
      <div class="col-lg-12">
        <ngb-accordion #acc="ngbAccordion">
          <ngb-panel id="rawDiff">
            <ng-template ngbPanelTitle="ngbPanelTitle"
              ><i
                class="card-title-content__icon glyphicon glyphicon-ab-plus"
                [ngClass]="{ 'is-opened': acc.isExpanded('rawDiff') }"
              ></i
              >Raw Diff</ng-template
            >
            <ng-template ngbPanelContent="ngbPanelContent">
              <table class="blob">
                <tbody>
                  <tr
                    *ngFor="
                      let line of diffStats.raw_diff;
                      trackBy: rawDiffStatsLineTrackBy
                    "
                  >
                    <td
                      class="blob-code"
                      [ngClass]="{
                        'blob-code--header':
                          line.indexOf('diff --git') === 0 ||
                          line.indexOf('diff -r') === 0,
                        'blob-code--addition':
                          line.indexOf('+') === 0 && line.indexOf('+++') !== 0,
                        'blob-code--deletion':
                          line.indexOf('-') === 0 && line.indexOf('---') !== 0,
                        'blob-code--summary': line.indexOf('@@') === 0
                      }"
                    >
                      {{ line }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>
    </div>
    <div class="ab-deploy-pagination">
      <div class="ab-deploy-pagination__section">
        <div *ngIf="prev">
          {{ timeToPrevDeploy | timeFormat }} before<br />by {{ prev.username }}
          <div class="ab-deploy-pagination__circle"></div>
          <div
            class="ab-deploy-pagination__line ab-deploy-pagination__line--in-right"
          ></div>
          <div class="ab-deploy-pagination__btn">
            <button
              class="btn"
              [disabled]="!prev"
              uiSref="deploys-show"
              [uiParams]="{ projectId: project.id, deployId: prev.id }"
              type="button"
            >
              <span class="d-md-none">Prev</span
              ><span class="d-none d-md-inline">Previous deploy</span>
            </button>
          </div>
        </div>
      </div>
      <div class="ab-deploy-pagination__section">
        <ab-env-label [env]="deploy.environment"></ab-env-label>
        <div class="ab-deploy-pagination__current">Current deploy</div>
        <div
          class="ab-deploy-pagination__line ab-deploy-pagination__line--in-left"
          *ngIf="prev"
        ></div>
        <div class="ab-deploy-pagination__circle"></div>
        <div
          class="ab-deploy-pagination__line ab-deploy-pagination__line--in-right"
          *ngIf="next"
        ></div>
        {{ deploy.createdAt | date: "h:mm a - MMMM dd, y" }}
      </div>
      <div class="ab-deploy-pagination__section">
        <div *ngIf="next">
          {{ timeToNextDeploy | timeFormat }} after<br />by {{ next.username }}
          <div
            class="ab-deploy-pagination__line ab-deploy-pagination__line--in-left"
          ></div>
          <div class="ab-deploy-pagination__circle"></div>
          <div class="ab-deploy-pagination__btn">
            <button
              class="btn"
              [disabled]="!next"
              uiSref="deploys-show"
              [uiParams]="{ projectId: project.id, deployId: next.id }"
              type="button"
            >
              <span class="d-md-none">Next</span
              ><span class="d-none d-md-inline">Next deploy</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
